import { createContext, ReactNode, useState } from 'react'

export interface IUploadContextProps {
  file: File | null
  setFile: (data: File | null) => void
}

// eslint-disable-next-line react-refresh/only-export-components
export const UploadContext = createContext({} as IUploadContextProps)

export const UploadContextProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [file, setFile] = useState<File | null>(null)

  return (
    <UploadContext.Provider
      value={{
        file,
        setFile,
      }}
    >
      {children}
    </UploadContext.Provider>
  )
}
